import { InjectionToken } from '@angular/core';

export const SN_DRAWER_DATA = new InjectionToken<any>('SnDrawerData');
